import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const Pagination = ({ pagination, loading, onLoadMore }) => {
  const { t } = useTranslation();

  const hasNextPage = useMemo(() => {
    const { page = 1, pages = 0 } = pagination || {};
    return page < pages;
  }, [pagination]);

  const showButton = useMemo(() => {
    return hasNextPage && !loading;
  }, [hasNextPage, loading]);

  return (
    <div className="member-center__pagination">
      {showButton && (
        <div className="member-center__pagination-button">
          <Button variant="listMore" onClick={onLoadMore}>
            {t('member.center.load.more')}
          </Button>
        </div>
      )}
      {loading && (
        <div className="member-center__pagination-loading">
          <img src="https://static.shoplineapp.com/web/v1/img/loaders/loader1.gif" />
        </div>
      )}
    </div>
  );
};

Pagination.propTypes = {
  pagination: PropTypes.exact({
    page: PropTypes.number,
    pages: PropTypes.number,
  }),
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

export default Pagination;
